<template lang="pug">
    #products
        v-banner.title-banner(min-height="88")
            .text-h4.font-weight-bold {{category=='sell'? $t('Menu.__Sales'): $t('Menu.__Purchase')}} : {{$t('Menu.__ProductAndService')}}
            template(v-slot:actions)
                v-btn.ml-6(rounded color="primary" @click="$router.push({name: 'ProductNew', params: {category: category}})")  {{$t('Products.__AddNewProduct')}}

        v-container
            Alert
            ConfirmDialog(v-model="deleteDialog" :title="$t('Products.__DeleteProduct')" :message="$t('Products.__ConfirmDeleteProduct')" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Delete')" :confirm-action="deleteProduct")

            v-data-table.mt-10.mb-6(:headers="headers" :items="products" hide-default-footer :options.sync="options" :loading="loading" :custom-sort="defaultDataSort")
                template(v-slot:item.category="{item}")
                    | {{item.category}}
                template(v-slot:item.name="{item}")
                    | {{item.name}}
                    .subtitle {{item.description}}
                template(v-slot:item.price="{item}")
                    | {{getAmountWithCurrency(item.price, currencyCode)}}
                    .subtitle(v-for="tax in item.taxes") + {{tax.name}} {{tax.rate}}%
                template(v-slot:item.actions="{item}")
                    v-btn.ma-0(text icon small color="primary" @click="editItem(item.id)" title="edit")
                        v-icon(small) edit
                    v-btn.ma-0(text icon small color="primary"  @click="deleteDialog=true;deleteId=item.id" title="delete" )
                        v-icon(small) delete
            v-row.pagination-row
                v-col.d-flex.align-center.justify-start(cols="6")
                    span.mr-2.d-none.d-md-block {{$t("Table.__ItemsPerPage")}}
                    span
                        v-select.page-select(v-model="options.itemsPerPage" solo dense outlined hide-details :items="perPageItems")
                v-col.d-flex.align-center.justify-end(cols="6")
                    v-pagination(v-model="options.page" :length="pageCount")

</template>
<script>
import * as datatableHelper from "@/utils/datatableHelper.js"
import * as currencyHelper from "@/utils/currencies"

export default {
  props: ["category", "alert"],
  mixins: [datatableHelper.mixin, currencyHelper.mixin],
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,

      deleteDialog: false,
      deleteId: 0,
      headers: [
        {
          text: this.$t("Products.__Type"),
          align: "start",
          sortable: true,
          value: "category"
        },
        {
          text: this.$t("Products.__Name"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: this.$t("Products.__Price"),
          align: "end",
          sortable: true,
          value: "price"
        },
        {
          text: "",
          align: "end",
          width: "120px",
          sortable: false,
          value: "actions"
        }
      ],
      products: []
    }
  },
  methods: {
    getProducts() {
      var query = this.datatableOptionsToQuery(this.options)
      this.loading = true

      if (this.category == "buy") {
        query.type = "Buy"
      } else {
        query.type = "Sell"
      }
      // this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("products/getProducts", query)
        .then(
          function(response) {
            this.pageCount = response.paging.totalPages
            this.products = response.data.filter(
              function(product) {
                if (product.incomeAccountId != null && product.expenseAccountId != null) {
                  product.category = this.$t("Products.__Sell") + "&" + this.$t("Products.__Buy")
                  // product.total = this.getTotalAmount(product)
                  return true
                } else if (this.category == "buy" && product.expenseAccountId != null) {
                  product.category = this.$t("Products.__Buy")
                  // product.total = this.getTotalAmount(product)
                  return true
                } else if (this.category == "sell" && product.incomeAccountId != null) {
                  product.category = this.$t("Products.__Sell")
                  // product.total = this.getTotalAmount(product)
                  return true
                }
                return false
              }.bind(this)
            )
            // this.products
            // for (var product of this.products) {
            //     product.total = this.getTotalAmount(product)
            // }
            // this.$store.dispatch("global/stopLoading")
            this.loading = false
          }.bind(this)
        )
        .catch(
          function(error) {
            this.loading = false
          }.bind(this)
        )
    },
    editItem(pid) {
      this.$router.push({
        name: "ProductInfo",
        params: {
          id: pid
        }
      })
    },
    deleteProduct() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("products/deleteProduct", this.deleteId)
        .then(
          function(response) {
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
            this.getProducts()
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    getTotalAmount(item) {
      var total = item.price

      for (var tax of item.taxes) {
        total = total * (1 + tax.rate / 100)
      }
      return total
    }
  },
  watch: {
    category() {
      this.getProducts()
    },
    options: {
      handler() {
        this.getProducts()
      },
      deep: true
    }
  },
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    this.getProducts()
  }
}
</script>

<style lang="scss">
// @media (min-width: 1264px) {
//     .container {
//         max-width: 100%;
//         padding: 40px;
//     }
// }

.subtitle {
  opacity: 0.66;
  font-family: NotoSansCJKtc;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #505356;
}
</style>
